/**
 * View Management Redux action type constants.
 */
import { ViewManagementPageType } from './ViewManagement.types';

export const VIEW_MGMT_FETCH_MASTERDATA_SUCCESS = 'VIEW_MGMT_FETCH_MASTERDATA_SUCCESS';

export const VIEW_MGMT_FETCH_PREFERENCE_SUCCESS = 'VIEW_MGMT_FETCH_PREFERENCE_SUCCESS';

export const VIEW_MGMT_SET_LOADING = 'VIEW_MGMT_SET_LOADING';

export const VIEW_MGMT_SET_FILTER_LIST = 'VIEW_MGMT_SET_FILTER_LIST';

export const CN_TRACKING_PAGE_TYPE: ViewManagementPageType = 'ops_consignment_tracking';

export const CN_TRACKING_BUCKET = 'cn_tracking';
